import ApiService from "../common/api.service";
import {FETCH_SURVEY, SUBMIT_SURVEY} from "./actions.type";
import {
  SET_SURVEY,
  SET_ERROR,
} from "./mutations.type";
import {checkForCustomDomain, checkIfCompleted, isPreviewMode, setCompleted, shuffle} from "../helpers/fns";

const state = {
  survey: {},
  error: {},
  needPassword: false,
  showBranding: false,
}

const getters = {
  survey(state) {
    return state.survey;
  },
  questions(state) {
    const questions = state.survey.questions?.rows || [];

    if (state.survey.randomize_questions) {
      shuffle(questions);
    }

    return questions;
  },
  error(state) {
    return state.error;
  },
  needPassword(state) {
    return state.needPassword;
  },
  showBranding(state) {
    return state.showBranding;
  },
}

const actions = {
  [FETCH_SURVEY]: async ({commit}, payload) => {
    const {surveyId, password} = payload;
    let query = password ? `?password=${password}` : '';

    try {
      const completed = await checkIfCompleted(surveyId);
      if (completed) {
        query += (query ? '&' : '?') + 'completed=true';
      }

      const survey = await ApiService.get(`${process.env.VUE_APP_API_URL}/survey/${surveyId}${query}`);
      checkForCustomDomain(survey);

      commit(SET_SURVEY, survey);
      return survey;
    } catch (error) {
      commit(SET_ERROR, error);
      return Promise.reject(error);
    }
  },
  [SUBMIT_SURVEY]: async (context, payload) => {
    if (isPreviewMode) return;

    const {surveyId} = payload;

    try {
      setCompleted(surveyId, payload);

      return await ApiService.post(
        `${process.env.VUE_APP_API_URL}/survey/${surveyId}`,
        payload
      );
    } catch (error) {
      return Promise.reject(error);
    }
  },
}

const mutations = {
  [SET_SURVEY](state, survey) {
    state.error = {};
    state.needPassword = false;
    state.survey = survey;
    state.showBranding = survey?.hasBranding;
  },
  [SET_ERROR](state, error) {
    if (error?.type === 'NEED_PASSWORD' || error?.type === 'WRONG_PASSWORD') {
      state.needPassword = true;
    }

    state.error = error;
    state.showBranding = error?.data?.hasBranding;
  },
}

export default {
  state,
  actions,
  mutations,
  getters
};
